import { create } from 'zustand';
import { AccountApi, ApiUtils, type SetAccountPartnerAccountNumberRequest, type StoreBaseReturn } from '@shared/api';

interface UseSetPartnerAccountNumberStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  setPartnerAccountNumber: (request: SetAccountPartnerAccountNumberRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useSetPartnerAccountNumberStore = create<UseSetPartnerAccountNumberStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  setPartnerAccountNumber: async (request, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await AccountApi.setPartnerAccountNumber(request, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
